var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUrlLinkFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.967
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3820",
    d: "M6.428 16.859l4.05-4.082a3.705 3.705 0 00-.014-5.239l-.026-.025a1.8 1.8 0 00-.514-.417.718.718 0 10-.74 1.227 2.219 2.219 0 01.244.207 2.273 2.273 0 01.059 3.214l-.027.027-4.065 4.079a2.324 2.324 0 01-3.264.022 2.279 2.279 0 01-.038-3.223l.016-.016 3.336-3.358.02-.016a.722.722 0 10-1.028-1l-.025.025-3.331 3.347a3.7 3.7 0 00.007 5.239l.023.023a3.776 3.776 0 005.311-.031zm5.144-15.753l-4.05 4.082a3.705 3.705 0 00.014 5.239l.025.025a1.8 1.8 0 00.514.417.718.718 0 10.74-1.227 2.064 2.064 0 01-.244-.207 2.275 2.275 0 01-.061-3.214l.027-.027 4.068-4.078a2.324 2.324 0 013.264-.022 2.279 2.279 0 01.038 3.223l-.016.016-3.336 3.358-.02.016a.711.711 0 00-.261.557.721.721 0 001.288.446l.025-.025 3.331-3.347a3.705 3.705 0 00-.007-5.239l-.023-.023a3.776 3.776 0 00-5.311.031z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/url_link_full.c33ad58f05305b7e28bb3589eb7a9be9.svg";
export { SvgUrlLinkFull as ReactComponent };